var convert = require('./convert'),
    func = convert('eq', require('../eq'));

func.placeholder = require('./placeholder');
module.exports = func;



/*****************
 ** WEBPACK FOOTER
 ** ./~/semantic-ui-react/~/lodash/fp/eq.js
 ** module id = 4046
 ** module chunks = 0
 **/